import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-icon',
    templateUrl: './app-icon.component.html',
    styleUrl: './app-icon.component.scss',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppIconComponent {
    @Input() icon?: string;
}
